interface Article {
  title: string;
  slug: string;
  content: string[];
  lastUpdated: Date;
}

interface CategoryArticles {
  [category: string]: {
    [slug: string]: Article;
  };
}

export const articles: CategoryArticles = {
  account: {
    "delete-account": {
      title: "How do I delete my account?",
      slug: "delete-account",
      content: [
        "Users cannot currently delete their account. If you would like to delete your account, please contact our Support Team with the email address linked to your account.",
        "Please understand that once your account is deleted, all data associated with your account will be lost and cannot be recovered."
      ],
      lastUpdated: new Date("2024-03-24T12:00:00Z")
    },
    "change-password": {
      title: "How do I change my password?",
      slug: "change-password",
      content: [
        "You can change your password at any time through your account settings on the dashboard.",
        "Go to the Dashboard -> Click the Reset Password Button -> Enter Your Email Address.",
        "You'll recieve and email with a link to reset your password."
      ],
      lastUpdated: new Date("2024-03-20T15:30:00Z")
    },
    "update-email": {
      title: "How do I update my email?",
      slug: "update-email",
      content: [
        "Currently users cannot update their email address on their own. If you would like to update your email address, please contact our Support Team with the email address linked to your account.",
        "The support team will be more than happy to migrate your account to the new email address."
      ],
      lastUpdated: new Date("2024-03-22T10:00:00Z")
    }
  },
  billing: {
    "cancel-subscription": {
      title: "How do I cancel my subscription?",
      slug: "cancel-subscription",
      content: [
        "You can cancel your subscription at any time and you will continue to have access to your plan until the end of the period",
        "Go to Settings (in the top right) -> Billing -> Manage billing -> Cancel plan.",
        "Please confirm that the subscription is successfully cancelled and it will not renew at the end of the billing period."
      ],
      lastUpdated: new Date("2024-03-24T12:00:00Z")
    },
    "update-payment": {
      title: "How do I update my payment method?",
      slug: "update-payment",
      content: [
        "You can update your payment method at any time through your account settings.",
        "Go to Settings -> Billing -> Payment methods -> Add new method or Update existing method.",
        "Your subscription will automatically use the new payment method for future billing cycles."
      ],
      lastUpdated: new Date("2024-03-20T15:30:00Z")
    }
  },
  troubleshooting: {
    "qr-not-scanning": {
      title: "QR code is not scanning",
      slug: "qr-not-scanning",
      content: [
        "If your QR code is not scanning, try these troubleshooting steps:",
        "1. Ensure the QR code has enough contrast",
        "2. Make sure there's adequate lighting",
        "3. Hold the scanner at the right distance",
        "4. Check if the QR code is not damaged or distorted"
      ],
      lastUpdated: new Date("2024-03-21T09:00:00Z")
    },
    "analytics-issues": {
      title: "Analytics not showing up",
      slug: "analytics-issues",
      content: [
        "If you're experiencing issues with analytics:",
        "1. Check your internet connection",
        "2. Clear your browser cache",
        "3. Make sure you're viewing the correct date range",
        "4. Verify that your QR code has received scans in the selected period"
      ],
      lastUpdated: new Date("2024-03-23T14:00:00Z")
    }
  },
  // Add other categories and their articles as needed
}; 